<app-card [titleKey]="translationKey + 'cardTitle'">
  <app-info-label [label]="translationKey + 'infoLabel'" />
  <div class="risk-factors-content">
    <div class="text-box" [class.empty]="!riskFactorsText()">
      {{ riskFactorsText() || ('projectDetails.sectionC.noContent' | translate) }}
    </div>
    <div class="char-count">{{ riskFactorsLength() }} / 2000</div>
  </div>
</app-card>
